// extracted by mini-css-extract-plugin
export var active = "_3y-7";
export var container = "_3y-0";
export var evenWidth = "_3y-4";
export var large = "_3y-5";
export var outlet = "_3y-8";
export var slide = "_3y-2";
export var small = "_3y-6";
export var tab = "_3y-3";
export var tabs = "_3y-1";